var fMovies 	= [];
var videoTimes 	= [];
var mainMoviePC, mainMovieSP;
videojs.hook('setup', function(player){
	var id = player.id_;
	if(id === "video-1" || id === "video-2" || id === "video-3" || id === "video-4"){
		player.muted(true);
		player.pause();
		if(id === "video-1"){
			fMovies[0] = player;
			var $video1 = $("#video-foundation01 .movie");
			var $blockID = $("#video-foundation01")
			common.checkVideoTimeupdate("video-foundation01", player, "main_movie");
			$("#video-foundation01 .video-js video").off().on("click", function(){
				var $thisMovie = $(this).parent();
				if($thisMovie.hasClass("active")){
					$thisMovie.removeClass("active");
				}else{
					$thisMovie.addClass("active");
				}
			});
			$("#video-foundation01 a.thumb").off().on("click", function(){
				if(!$("#video-foundation01 .movie").hasClass("playing")){
					$("#video-foundation01 .movie").addClass("playing");
				}
				fMovies[0].play();
			});
			$("#video-foundation01 .ui-video .btn-playback").off().on("click", function(){
				var $this = $(this);
				player.currentTime(0);
				//google analytics
				let label 		= $this.attr("data-ga");
				let category 	= $this.attr("data-category");
				let action 		= "back"
				common.sendClickGa(label, category, action);
			});
			$("#video-foundation01 .ui-video .btn-toggleplay").off().on("click", function(){
				var $this = $(this);
				if(player.paused()){
					$this.removeClass("active");
					player.play();
					//google analytics
					var label = $this.attr("data-ga");
					var category = $this.attr("data-category");
					var action = "play";
				} else {
					$this.addClass("active");
					player.pause();
					//google analytics
					var label = $this.attr("data-ga");
					var category = $this.attr("data-category");
					var action = "stop";
				}
				common.sendClickGa(label, category, action);
			});
			$("#video-foundation01 .ui-video .btn-volume").off().on("click", function(){
				var $this = $(this);
				if(player.muted()){
					$this.addClass("active");
					player.muted(false);
				} else {
					$this.removeClass("active");
					player.muted(true);
				}
			});
		}else if(id === "video-2"){
			//console.log(id, player)
			fMovies[1] = player;
			//3番目の値はGAにわたす値
			common.checkMotionTimeupDate("video-2", player, "video-foundation02");
		}else if(id === "video-3"){
			fMovies[2] = player;
			//3番目の値はGAにわたす値
			common.checkMotionTimeupDate("video-3", player, "video-foundation03");
		}else if(id === "video-4"){
			fMovies[3] = player;
		}
	}
});
var vol3 = {
	players: [],
	timer: "",
	init: function(){
		let $body = $("body");
		var imgArry = [];
		this.resize();
		$(".video-js").each(function(i){
			var thisID = $(this).attr("id");
			videojs(thisID);
		});

		$("#wrapper img").each(function(){
			imgArry.push($(this).attr("src"));
		});
		preloadPage.startLoad(imgArry.length,imgArry, 0).done(function(){
			vol3.startContent();
		});

		$("#block-nav").on("touchmove", function(e){
			if($html.classList.contains("show-nav")){
				e.preventDefault();
			}
		});
	},
	startContent: function(){
		let $body = $("body");
		$body.removeClass("disable");
		setTimeout(function(){
			$("#foundation #main").addClass("active");
			//動画終わり
			setTimeout(function(){
				$body.removeClass("fixed");
				$("#loading").remove();
				setTimeout(function(){
					let posY = $("#ttl-page .ttl-page-content").offset().top;
					common.scrollToPosition(posY, 600);
				},100);
			},1500);
		},400);
		$(document).on("scroll touchmove", function(){
			vol3.scrl();
		});
		vol3.nav();
	},
	nav: function(){
		let $body = $("body"),
			modalMovie = $("#video-4")[0];

		modalMovie.addEventListener('ended', function() {
			modalMovie.currentTime = 0;
		}, false);
		$("a.btn-modal").off().on("click", function(){
			let $this = $(this);
			if(!$html.classList.contains("show-movie")){
				common.sendClickGa("modal_open", "main_movie", "click");

				$html.classList.add("movie");
				setTimeout(function(){
					$html.classList.add("show-movie");
					setTimeout(function(){
						fMovies[3].play();
						$("#video-4_html5_api").off().on("ended", function(){
							$("#video-4_html5_api")[0].currentTime = 0;
						});
						if($("#video-1").hasClass("vjs-playing")){
							fMovies[0].pause();
						}
					},600);
				},50);
			}
		});
		$("#bg-movie").off().on("click", function(){
			closeMovie();
		});
		$("a.btn-close-movie").off().on("click", function(){
			closeMovie();
		});
		function closeMovie(){
			if($html.classList.contains("show-movie")){
				$html.classList.remove("show-movie");
				setTimeout(function(){
					$html.classList.remove("movie");
					fMovies[4].pause();
				},600);
			}
		}
	},
	resize: function(){
		let winW = $(window).width(),
			winH = $(window).height();
		let rx = 1114,
			ry = 750,
			minw = 960,
			minh = 646;

		if(isSmallScreen){
			$("#main #bg_main").css({
				"width": winW + "px",
				"height": winH + "px"
			})
		}else{
			$("#main #bg_main").css({
				"width": "",
				"height": ""
			})
		}
	},
	scrl: () =>{
		var topD = $(document).scrollTop(),
			btmD = topD + $(window).height(),
			alen = animates.length,
			winH = $(window).height(),
			$body = $("body");
		common.checkScrolledPos(topD);
		for(var a = 0; a < alen; a++){
			if(a === alen - 1){
				if(btmD >= animates[a].show){
					activeAnimation(a)
				}
			}else{
				if(btmD >= animates[a].show){
					activeAnimation(a)
				}
			}
		}
		if(btmD > winH){
			if(!$body.hasClass("hide_logo")){
				$body.addClass("hide_logo");
			}
		}else{
			if($body.hasClass("hide_logo")){
				$body.removeClass("hide_logo");
			}
		}

		//Parallax
		var bg01Top = $("#blk-foundation01 .movie").offset().top + $("#blk-foundation01 .movie").outerHeight();
		if(btmD > bg01Top){
			if(!$body.hasClass("show_bg")){
				$body.addClass("show_bg");
			}
		}else{
			if($body.hasClass("show_bg")){
				$body.removeClass("show_bg");
			}
		}
		
		if(btmD > $("#blk-foundation03 .btn-watch").offset().top){
			if(!$body.hasClass("show_bg02")){
				$body.addClass("show_bg02");
			}
		}else{
			if($body.hasClass("show_bg02")){
				$body.removeClass("show_bg02");
			}
		}
		
		if(btmD >= $(document).height()-50){
			if(!$body.hasClass("btm")){
				$body.addClass("btm");
			}
		}else{
			if($body.hasClass("btm")){
				$body.removeClass("btm");
			}
		}
		var movie1Top = $("#video-foundation01 .movie").offset().top,
			movie1Btm = movie1Top + $("#video-foundation01 .movie").outerHeight() + winH;
		//console.log(movie2top, movie2btm)
		if(btmD < movie1Top){
			if($("#video-1").hasClass("vjs-playing")){
				fMovies[0].pause();
			}
		}else if(btmD > movie1Btm){
			if($("#video-1").hasClass("vjs-playing")){
				fMovies[0].pause();
			}
		}else{
			if($("#video-1").hasClass("vjs-paused") && !$("#video-1").hasClass("played")){
				var $blk = $("#video-foundation01");
				if(!$blk.hasClass("animate")){
					$blk.addClass("animate");
					setTimeout(function(){
						$blk.addClass("animated");
					},2000);
				}
				fMovies[0].play();
				var category 	= "main_movie",
					label 	 	= "start_play",
					action 		= "play";
				common.sendClickGa(label, category, action);
				$("#video-1").addClass("played");
			}
		}

		//lipVideos[3]
		var video2Top = $("#video-2").offset().top;
		var video2Btm = video2Top + $("#video-2").outerHeight();
		if(btmD >= video2Top && topD < video2Btm){
			if(!$("#video-2").hasClass("vjs-playing")){
				fMovies[1].play();
				//初回の再生時だけGAをtimeupdateに頼らず送るためのplayed
				if(!$("#video-2").hasClass("played")){
					$("#video-2").addClass("played");
					let category 	= "motion02";
					let action 		= "play";
					let label 		= "start"
					common.sendClickGa(label, category, action);
				}
			}
		}else if(btmD < video2Top){
			if($("#video-2").hasClass("vjs-playing")){
				fMovies[1].pause();
			}
		}
		if(topD >= video2Btm){
			if($("#video-2").hasClass("vjs-playing")){
				fMovies[1].pause();
			}
		}
		
		var movie3Top = $("#video-foundation03 .movie").offset().top,
			movie3Btm = movie3Top + $("#video-foundation03 .movie").outerHeight() + winH;
		if(btmD < movie3Top){
			if($("#video-3").hasClass("vjs-playing")){
				fMovies[2].pause();
			}
		}else if(btmD > movie3Btm){
			if($("#video-3").hasClass("vjs-playing")){
				fMovies[2].pause();
			}
		}else{
			if($("#video-3").hasClass("vjs-paused")){
				fMovies[2].play();
				if(!$("#video-3").hasClass("played")){
					var category 	= "main_movie",
						label 	 	= "start_play",
						action 		= "play";
					common.sendClickGa(label, category, action);
					$("#video-3").addClass("played");
				}
			}
		}
		/**/
		function activeAnimation(a){
			var $block = $(".a").eq(a);
			if(!$block.hasClass("animate")){
				$block.addClass("animate");
				if($block.attr("data-movieid") === "1"){
					setTimeout(function(){
						if($("#video-foundation01 .movie").hasClass("active")){
							$("#video-foundation01 .movie").removeClass("active");
						}
					},2000);
				}
				if($block.attr("data-movieid") === "3"){
					setTimeout(function(){
						if($("#video-foundation03 .movie").hasClass("active")){
							$("#video-foundation03 .movie").removeClass("active");
						}
					},2000);
				}
				setTimeout(function(){
					$block.addClass("animated");
				},1000);
			}
		}
		//ga
		var galen = gablocks.length;
		for(var g = 0; g < galen; g++){
			if(btmD >= gablocks[g].top){
				activeGa(g)
			}
		}
		function activeGa(g){
			var $blk = $(".gablock").eq(g);
			if(!$blk.hasClass("active")){
				$blk.addClass("active");
				var label = $blk.attr("data-ga");
				common.sendScrollPageGa(label);
			}
		}
	}
}